import type { School } from '../../models/School';
import type { SupabaseClient } from 'jsr:@supabase/supabase-js@2';
import { SupabaseRepository } from '../supabaseRepository/SupabaseRepository.ts';

const selector = `id, name, region_id, created_at`;

export class SchoolRepository extends SupabaseRepository<School> {
  constructor(client: SupabaseClient) {
    super('schools', selector, client);
  }
}
